export interface T_PROCESSOR_REDUCER {
  fetchTransmitters: boolean
}

export const INITIAL_STATE: T_PROCESSOR_REDUCER = {
  fetchTransmitters: false
}
